import Api from '../../Api';
import { ICreateEncouragementRequest } from '../../shared-interfaces/Notation/Encouragement/ICreateEncouragementRequest';
import { IMultiStudentCreateEncouragementRequest } from '../../shared-interfaces/Notation/Encouragement/IMultiStudentCreateEncouragementRequest';
import { INotation } from '../../shared-interfaces/Notation/INotation';

const EncouragementService = {
  create: async (request: ICreateEncouragementRequest) => {
    await Api.post(`notation/encouragement`, request);
  },
  createMultiple: async (request: IMultiStudentCreateEncouragementRequest) => {
    const response = await Api.post(`notation/encouragement/multiple`, request);
    return response.data as INotation[];
  },
  delete: async (id: number) => {
    await Api.delete(`notation/encouragement/${id}`);
  },
};

export default EncouragementService;
